import api from "../api/axios";

export const getDepartmentById = async (company_id) => {
  try {
    const response = await api.get(`department/${company_id}`);
    console.log("Department response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching department:", error);
    throw error;
  }
};

export const getDepartmentDetails = async (department_id) => {
  try {
    const response = await api.get(`department/details/${department_id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching department details:", error);
    throw error;
  }
};

export const addDepartment = async (company_id, data) => {
  try {
    const response = await api.post(`department/add-department/${company_id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error adding department:", error);
    throw error;
  }
};

export const updateDepartment = async (department_id, company_id, data) => {
  try {
    const response = await api.put(`department/${department_id}/${company_id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating department:", error);
    throw error;
  }
};

export const deleteDepartment = async (department_id, company_id) => {
  try {
    const response = await api.delete(`department/deleteDepartment/${department_id}`, {
      data: { companyId: company_id }
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting department:", error);
    throw error;
  }
};
